<template>
  <main class="main" role="main">
    <div class="main_con" v-if="!fetchCompleted">
      <div class="store_list_wrap">
        <SkeletonStoreItem v-for="index in 6" :key="index" />
      </div>
    </div>
    <div class="main_con" v-else>
      <template v-if="shops.totalElements">
        <div class="store_list_wrap">
          <Shop2
            class="pnt"
            v-for="shop in shops.content"
            :store="shop"
            @toggle="toggleFollow(shop, shop.id)"
            :key="shop.id"
          />
        </div>
      </template>
      <template v-else>
        <div class="empty_wrap">
          <div class="empty">
            <!--'기본: ', '준비중: ready', '결과없음: result'-->
            <div class="msg">
              <div>관심매장이 없습니다.</div>
            </div>
          </div>
        </div>
      </template>
    </div>
  </main>
</template>
<script>
import Shop2 from '@/front/customer/views/shops/components/Shop2.vue';
import {
  mapActions as shopMapActions,
  mapGetters as shopMapGetters,
} from '@common/store/modules/shop';
import * as shopTypes from '@common/store/modules/shop/types';

import {
  mapActions as estimateMapActions,
  mapGetters as estimateMapGetters,
} from '@common/store/modules/estimate';
import * as estimationTypes from '@common/store/modules/estimate/types';

import { mapActions as commonMapActions } from '@common/store/modules/common';
import * as commonActions from '@common/store/modules/common/types';
import { authMapGetters, authGetters } from '@common/store/modules';
import SkeletonStoreItem from '@common/components/shop/SkeletonItem/StoreItem.vue';

export default {
  components: {
    Shop2,
    SkeletonStoreItem,
  },
  computed: {
    ...shopMapGetters({
      shops: shopTypes.SHOPS,
    }),
    ...authMapGetters({
      currentUser: authGetters.CURRENT_USER,
    }),
    ...estimateMapGetters({
      autoEstimation: estimationTypes.AUTO_ESTIMATION,
    }),
  },
  created() {
    this.getFollowShops();
  },
  data() {
    return {
      PAGE: 1,
      PAGE_SIZE: 100,
      fetchCompleted: false,
    };
  },
  methods: {
    ...shopMapActions([
      shopTypes.FETCH_SHOPS,
      shopTypes.SHOP_FOLLOW,
      shopTypes.SHOP_UNFOLLOW,
      shopTypes.FETCH_SHOP,
    ]),
    ...commonMapActions([commonActions.SET_DIALOG, commonActions.HIDE_DIALOG]),
    ...estimateMapActions([estimationTypes.FETCH_AUTO_ESTIMATION_IN_PROGRESS]),
    async getFollowShops() {
      const params = {
        follow: true,
        isNearby: false,
        page: this.PAGE,
        size: this.PAGE_SIZE,
        isLoading: false,
      };
      await this[shopTypes.FETCH_SHOPS](params);
      this.fetchCompleted = true;
    },

    async toggleFollow(shop, id) {
      const self = this;
      const funAutoEstimationInProgress = async () => {
        await self[estimationTypes.FETCH_AUTO_ESTIMATION_IN_PROGRESS]({
          userId: self.currentUser.id,
          storeId: id,
        });
      };
      const funToggle = async function() {
        await self[
          shop.followed ? shopTypes.SHOP_UNFOLLOW : shopTypes.SHOP_FOLLOW
        ]({ id: id });
        await self.getFollowShops();
      };
      if (shop.followed) {
        await funAutoEstimationInProgress();
        if (self.autoEstimation.id) {
          self[commonActions.SET_DIALOG]({
            type: 'confirm',
            icon: 'warning',
            //title: this.$t('common.confirm'),
            message:
              '관심매장 해지시 자동견적서 발송이 취소 됩니다. 해지 하시겠습니까?',
            okCb: async () => {
              await funToggle();
              //this.$router.go(-1);
            },
            cancelCb: async () => {
              await this.getFollowShops();
            },
          });
        } else {
          await funToggle();
        }
      } else {
        await funToggle();
      }
    },
  },
};
</script>
